import './styles/miniCard.css'
export default function MiniCard({fadeOut, displayText, icon}) {
    return (
        <article className={`mini-card cursor-detect-hover${fadeOut ? " fade-out" : ""}`}>
            <div className="cursor-hoverable card-inner">
                <div className="icon">
                    <img src={icon} alt="Logo de la technologie utilisée" />
                </div>
                <p>{displayText}</p>
            </div>
        </article>
    );
};